<select [(ngModel)]="vd" name="valuationDate" (change)="onChange()" class="form-control" aria-label="Valuation Date Picker">
  @for (d of dates; track d) {
    <option [ngValue]="d">{{d | date:'MMMM d, yyyy'}}</option>
  }
</select>
